module.exports = __webpack_public_path__ + "static/img/l-5.8430ea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/products/l-5.png
// module id = Ml2b
// module chunks = 0